import { t } from '@lingui/macro';
import { Chip } from '@pocketlaw/tetris';
import { ReviewFeedbackCriticality } from 'shared/domains/apollo/generated/types';
export const getChip = (criticality) => {
    switch (criticality) {
        case ReviewFeedbackCriticality.Critical:
            return (<Chip variant="solid" appearance="danger" label={t({
                    message: 'Critical',
                    comment: 'Plai drawer - review feedback badge label - critical',
                })}/>);
        case ReviewFeedbackCriticality.Notable:
            return (<Chip variant="solid" appearance="warning" label={t({
                    message: 'Notable',
                    comment: 'Plai drawer - review feedback badge label - notable',
                })}/>);
        case ReviewFeedbackCriticality.Minor:
            return (<Chip variant="solid" appearance="info" label={t({
                    message: 'Minor',
                    comment: 'Plai drawer - review feedback badge label - minor',
                })}/>);
        default:
            return null;
    }
};
